var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMixedBuildingImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 136.699,
    y: 256,
    style: {
      fill: "#EDEDED"
    },
    width: 238.602,
    height: 169.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 256,
    style: {
      fill: "#DBDBDB"
    },
    width: 119.301,
    height: 169.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.408,
    y: 325.592,
    style: {
      fill: "#F8F8F9"
    },
    width: 139.184,
    height: 99.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 325.592,
    style: {
      fill: "#EDEDED"
    },
    width: 69.592,
    height: 99.417
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D38D94"
    },
    points: "256,275.884 176.466,325.592 335.534,325.592 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C18089"
    },
    points: "256,275.884 256,325.592 335.534,325.592 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.117,
    y: 385.243,
    style: {
      fill: "#BFA993"
    },
    width: 39.767,
    height: 39.767
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 385.243,
    style: {
      fill: "#B29A7E"
    },
    width: 19.883,
    height: 39.767
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88888F"
    },
    d: "M256,432.466c-4.118,0-7.456-3.337-7.456-7.456v-19.883c0-4.119,3.338-7.456,7.456-7.456 c4.119,0,7.456,3.337,7.456,7.456v19.883C263.456,429.129,260.119,432.466,256,432.466z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.223,
    y: 126.757,
    style: {
      fill: "#EDEDED"
    },
    width: 79.534,
    height: 39.767
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.34,
    y: 156.583,
    style: {
      fill: "#F8F8F9"
    },
    width: 119.301,
    height: 268.427
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.243,
    y: 126.757,
    style: {
      fill: "#DBDBDB"
    },
    width: 79.534,
    height: 39.767
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.359,
    y: 156.583,
    style: {
      fill: "#EDEDED"
    },
    width: 119.301,
    height: 268.427
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95D5A7"
    },
    d: "M82.019,425.01c8.236,0,14.913-6.677,14.913-14.913c0-5.284-2.756-9.914-6.9-12.563 c1.223-2.163,1.929-4.658,1.929-7.318c0-8.237-6.677-14.913-14.913-14.913c-3.825,0-7.302,1.451-9.942,3.82 c-2.64-2.368-6.117-3.82-9.942-3.82s-7.302,1.451-9.942,3.82c-2.64-2.368-6.117-3.82-9.942-3.82 c-8.236,0-14.913,6.676-14.913,14.913c0,2.661,0.706,5.155,1.928,7.318c-4.144,2.649-6.899,7.279-6.899,12.563 c0,8.236,6.677,14.913,14.913,14.913H82.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80CB93"
    },
    d: "M479.689,425.01c8.236,0,14.913-6.677,14.913-14.913c0-5.284-2.756-9.914-6.9-12.563 c1.223-2.163,1.929-4.658,1.929-7.318c0-8.237-6.677-14.913-14.913-14.913c-3.825,0-7.302,1.451-9.942,3.82 c-2.64-2.368-6.117-3.82-9.942-3.82s-7.302,1.451-9.942,3.82c-2.64-2.368-6.117-3.82-9.942-3.82 c-8.236,0-14.913,6.676-14.913,14.913c0,2.661,0.706,5.155,1.929,7.318c-4.144,2.649-6.9,7.279-6.9,12.563 c0,8.236,6.677,14.913,14.913,14.913H479.689z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 176.466,
    style: {
      fill: "#7AB9E8"
    },
    width: 49.709,
    height: 29.825
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M504.544,417.553h-3.768c0.828-2.334,1.283-4.843,1.283-7.456c0-5.529-2.013-10.738-5.568-14.765 c0.395-1.673,0.598-3.391,0.598-5.117c0-5.34-1.884-10.247-5.018-14.097c0.029-0.269,0.047-0.542,0.047-0.817V156.583 c0-4.119-3.338-7.456-7.456-7.456h-12.427v-22.369c0-4.119-3.338-7.456-7.456-7.456h-32.311V86.99c0-4.119-3.338-7.456-7.456-7.456 c-4.118,0-7.456,3.337-7.456,7.456v32.311h-32.311c-4.118,0-7.456,3.337-7.456,7.456v22.369h-12.427 c-4.118,0-7.456,3.337-7.456,7.456v91.961h-94.447v-34.796h42.252c4.118,0,7.456-3.337,7.456-7.456v-29.825 c0-4.119-3.338-7.456-7.456-7.456H256c-4.118,0-7.456,3.337-7.456,7.456v72.078h-94.447v-91.961c0-4.119-3.338-7.456-7.456-7.456 h-12.427v-22.369c0-4.119-3.338-7.456-7.456-7.456H94.447V86.99c0-4.119-3.338-7.456-7.456-7.456c-4.118,0-7.456,3.337-7.456,7.456 v32.311H47.223c-4.118,0-7.456,3.337-7.456,7.456v22.369H27.34c-4.118,0-7.456,3.337-7.456,7.456v218.72 c0,0.275,0.018,0.548,0.047,0.815c-3.134,3.85-5.018,8.758-5.018,14.097c0,1.726,0.203,3.445,0.597,5.117 c-3.555,4.026-5.568,9.236-5.568,14.764c0,2.614,0.454,5.122,1.282,7.456H7.456c-4.118,0-7.456,3.337-7.456,7.456 c0,4.119,3.338,7.456,7.456,7.456h497.087c4.118,0,7.456-3.337,7.456-7.456C512,420.891,508.662,417.553,504.544,417.553z  M263.456,183.922h34.796v14.913h-34.796V183.922z M392.699,134.214h64.621v14.913h-64.621V134.214z M372.816,164.039h104.388 v203.95c-0.816-0.091-1.645-0.141-2.485-0.141c-3.479,0-6.875,0.811-9.942,2.34c-3.067-1.529-6.463-2.34-9.942-2.34 s-6.875,0.811-9.942,2.34c-3.067-1.529-6.463-2.34-9.942-2.34c-11.493,0-20.985,8.715-22.227,19.881h-17.54 c-4.118,0-7.456,3.337-7.456,7.456c0,4.119,3.338,7.456,7.456,7.456h13.718c-0.833,2.358-1.29,4.868-1.29,7.456 c0,2.614,0.454,5.122,1.283,7.456h-36.079V256V164.039z M54.68,134.214h64.621v14.913H54.68V134.214z M139.184,164.039V256v161.553 h-36.079c0.827-2.334,1.282-4.843,1.282-7.456c0-2.588-0.457-5.098-1.29-7.456h13.718c4.118,0,7.456-3.337,7.456-7.456 s-3.338-7.456-7.456-7.456h-17.54c-1.242-11.167-10.734-19.881-22.227-19.881c-3.479,0-6.875,0.811-9.942,2.34 c-3.067-1.529-6.463-2.34-9.942-2.34s-6.875,0.811-9.942,2.34c-3.067-1.529-6.463-2.34-9.942-2.34c-0.84,0-1.669,0.051-2.485,0.141 V164.039H139.184z M32.311,417.553c-4.112,0-7.456-3.344-7.456-7.456c0-2.548,1.293-4.896,3.459-6.281 c3.336-2.134,4.423-6.502,2.475-9.95c-0.639-1.132-0.963-2.359-0.963-3.651c0-4.112,3.344-7.456,7.456-7.456 c2.338,0,3.99,1.041,4.963,1.914c2.832,2.542,7.125,2.542,9.958,0c0.973-0.873,2.625-1.914,4.963-1.914 c2.338,0,3.99,1.041,4.963,1.914c2.832,2.542,7.125,2.542,9.958,0c0.973-0.873,2.625-1.914,4.963-1.914 c4.112,0,7.456,3.344,7.456,7.456c0,1.291-0.324,2.518-0.963,3.651c-1.949,3.448-0.861,7.816,2.475,9.95 c2.166,1.386,3.46,3.734,3.46,6.281c0,4.112-3.344,7.456-7.456,7.456H32.311z M154.097,263.456h203.806v154.097h-24.854v-84.505 h2.485c3.327,0,6.25-2.203,7.167-5.401c0.917-3.197-0.395-6.615-3.215-8.379l-79.534-49.709c-2.419-1.511-5.486-1.511-7.904,0 l-79.534,49.709c-2.82,1.763-4.133,5.182-3.215,8.379c0.917,3.198,3.841,5.401,7.168,5.401h2.485v84.505h-24.854V263.456H154.097z  M275.884,377.786h-39.767c-4.118,0-7.456,3.337-7.456,7.456v32.311h-34.796v-84.505h124.272v84.505H283.34v-32.311 C283.34,381.124,280.001,377.786,275.884,377.786z M202.465,318.136L256,284.677l53.535,33.459H202.465z M243.573,417.553v-24.854 h24.854v24.854H243.573z M429.981,417.553c-4.112,0-7.456-3.344-7.456-7.456c0-2.548,1.293-4.896,3.459-6.281 c3.336-2.134,4.423-6.502,2.475-9.95c-0.639-1.132-0.963-2.359-0.963-3.651c0-4.112,3.344-7.456,7.456-7.456 c2.339,0,3.99,1.041,4.963,1.914c2.832,2.542,7.125,2.542,9.958,0c0.973-0.873,2.625-1.914,4.963-1.914s3.99,1.041,4.963,1.914 c2.832,2.542,7.125,2.542,9.958,0c0.973-0.873,2.625-1.914,4.963-1.914c4.112,0,7.456,3.344,7.456,7.456 c0,1.291-0.324,2.518-0.963,3.651c-1.949,3.448-0.861,7.816,2.475,9.95c2.166,1.386,3.459,3.734,3.459,6.281 c0,4.112-3.344,7.456-7.456,7.456H429.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M57.165,203.806h59.65c4.118,0,7.456-3.337,7.456-7.456s-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456S53.047,203.806,57.165,203.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M57.165,243.573h59.65c4.118,0,7.456-3.337,7.456-7.456c0-4.119-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456C49.709,240.235,53.047,243.573,57.165,243.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M57.165,283.34h59.65c4.118,0,7.456-3.337,7.456-7.456c0-4.119-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456C49.709,280.002,53.047,283.34,57.165,283.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M57.165,323.107h59.65c4.118,0,7.456-3.337,7.456-7.456c0-4.119-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456C49.709,319.769,53.047,323.107,57.165,323.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M57.165,362.874h59.65c4.118,0,7.456-3.337,7.456-7.456s-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456S53.047,362.874,57.165,362.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M395.184,203.806h59.65c4.118,0,7.456-3.337,7.456-7.456s-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456S391.067,203.806,395.184,203.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M395.184,243.573h59.65c4.118,0,7.456-3.337,7.456-7.456c0-4.119-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456C387.728,240.235,391.067,243.573,395.184,243.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M395.184,283.34h59.65c4.118,0,7.456-3.337,7.456-7.456c0-4.119-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456C387.728,280.002,391.067,283.34,395.184,283.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M395.184,323.107h59.65c4.118,0,7.456-3.337,7.456-7.456c0-4.119-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456C387.728,319.769,391.067,323.107,395.184,323.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M395.184,362.874h59.65c4.118,0,7.456-3.337,7.456-7.456s-3.338-7.456-7.456-7.456h-59.65 c-4.118,0-7.456,3.337-7.456,7.456S391.067,362.874,395.184,362.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M226.175,347.961c-4.118,0-7.456,3.337-7.456,7.456v9.942c0,4.119,3.338,7.456,7.456,7.456 s7.456-3.337,7.456-7.456v-9.942C233.631,351.299,230.293,347.961,226.175,347.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M256,347.961c-4.118,0-7.456,3.337-7.456,7.456v9.942c0,4.119,3.338,7.456,7.456,7.456 c4.118,0,7.456-3.337,7.456-7.456v-9.942C263.456,351.299,260.118,347.961,256,347.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E2D31"
    },
    d: "M293.282,365.359v-9.942c0-4.119-3.338-7.456-7.456-7.456c-4.118,0-7.456,3.337-7.456,7.456v9.942 c0,4.119,3.338,7.456,7.456,7.456C289.943,372.816,293.282,369.478,293.282,365.359z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedBuildingImage);
export default __webpack_public_path__ + "static/media/MixedBuilding_Image.30da04dba251008a6a19a782a4198b96.svg";
export { ForwardRef as ReactComponent };